/**
 * This module is a fork of and modifies:
 * https://github.com/necolas/react-native-web
 *
 * The original source is (c) Nicolas Gallagher
 * and licensed under the MIT license found a
 * https://github.com/necolas/react-native-web/blob/master/LICENSE
 */

import isWebColor from "../isWebColor"
import processColor from "../processColor"

const normalizeColor = (
  color?: number | string | null,
  opacity: number = 1,
): string | undefined => {
  if (color == null) {
    return undefined
  }

  if (typeof color === "string" && isWebColor(color)) {
    return color
  }

  const colorInt = processColor(color)
  if (colorInt != null) {
    const r = (colorInt >> 16) & 255
    const g = (colorInt >> 8) & 255
    const b = colorInt & 255
    const a = ((colorInt >> 24) & 255) / 255
    const alpha = (a * opacity).toFixed(2)
    return `rgba(${r},${g},${b},${alpha})`
  }

  return undefined
}

export default normalizeColor
